import { render, staticRenderFns } from "./upload-announcement-image.html?vue&type=template&id=27147bf1&scoped=true&external"
import script from "./upload-announcement-image.js?vue&type=script&lang=js&external"
export * from "./upload-announcement-image.js?vue&type=script&lang=js&external"
import style0 from "./upload-announcement-image.scss?vue&type=style&index=0&id=27147bf1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27147bf1",
  null
  
)

export default component.exports